export * from './limits';
export * from './pricing';
export * from './regions';
export * from './upload';

export const BRANDING_STORAGE_URL = import.meta.env.VITE_BRANDING_STORAGE_URL || 'https://data.sendallfiles.com';
